import AppHeader from '../AppHeader'

export default {
  name: 'master-category-edit',
  created () {
    this.getCategory()
  },
  data () {
    return {
      canValidate: true,
      name: '',
      name_hurigana: '',
      category: [],
      isSaving: false,
      searchCallbackFlag: false
    }
  },
  computed: {
    authToken () {
      return window.localStorage.getItem('access_token')
    },
    validation () {
      let hiragana = /^[\u3040-\u309fー]+$/

      const validation = {
        name: !!this.category.name,
        name_hurigana: !!this.category.name_hurigana && hiragana.test(this.category.name_hurigana)
      }
      if (!this.canValidate) {
        Object.keys(validation).forEach(
          key => {
            validation[key] = true
          }
        )
      }
      return validation
    },
    validationAll () {
      if (!this.validation.name) return false
      if (!this.validation.name_hurigana) return false
      return true
    }
  },
  components: {
    AppHeader
  },
  methods: {
    async getCategory () {
      let res = await this.$store.dispatch('GET_CATEGORY', {id: this.$route.params.id})
                                  .catch(err => {
                                    console.log(err)
                                    return
                                  })

      this.category = res.category
      this.searchCallbackFlag = true
    },
    async onClickSave () {
      // 連打対応
      if (this.isSaving) return false
      this.isSaving = true

      // 保存処理
      await this.$store.dispatch('UPDATE_MASTER_CATEGORY', {
        data: {
          id: this.$route.params.id,
          name: this.category.name,
          name_hurigana: this.category.name_hurigana
        }
      })
      .catch(err => {
        console.error(err)
        return
      })

      // カテゴリー一覧へ戻る
      this.$router.push('/master_category_list')
    },
    onClickCancel () {
      this.$router.push('/master_category_list')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/master-category-edit.js